/* ============================================================
   CATERPY 世界展開（トップ用）
   - サイトありカードをホバー/タップすると、対応する地図の国旗ピンが光る
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-caterpy-global]').forEach(function (section) {
    var cards = section.querySelectorAll('.caterpy-global-card[data-country]');

    function pinFor(id) {
      return section.querySelector('.caterpy-global__pin[data-country="' + id + '"]');
    }

    cards.forEach(function (card) {
      var id = card.getAttribute('data-country');

      var on = function () {
        var pin = pinFor(id);
        if (pin) { pin.classList.add('is-hot'); }
      };
      var off = function () {
        var pin = pinFor(id);
        if (pin) { pin.classList.remove('is-hot'); }
      };

      card.addEventListener('mouseenter', on);
      card.addEventListener('mouseleave', off);
      card.addEventListener('focus', on);
      card.addEventListener('blur', off);

      card.addEventListener('touchstart', function () {
        section.querySelectorAll('.caterpy-global__pin.is-hot').forEach(function (p) {
          p.classList.remove('is-hot');
        });
        on();
      }, { passive: true });
    });
  });
})();